// @flow
import { connect } from 'react-redux';
import Container from '~/core/domains/container';
import { mapDispatchToProps, mapStateToProps, mergeProps } from './';

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Container);



// WEBPACK FOOTER //
// ./src/core/components/widgets/remove-device/redux.js